import { c as _c } from "react/compiler-runtime";
import { cn } from '@ncai-axe/react-ui-v3/utils';
import styles from './styles.module.scss';
type GridProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};
export const TopbarGrid = t0 => {
  const $ = _c(6);
  const {
    children,
    style,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.topbarGrid, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== style || $[4] !== t1) {
    t2 = <div className={t1} style={style}>{children}</div>;
    $[2] = children;
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const SidebarGrid = t0 => {
  const $ = _c(6);
  const {
    children,
    style,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.sidebarGrid, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== style || $[4] !== t1) {
    t2 = <div className={t1} style={style}>{children}</div>;
    $[2] = children;
    $[3] = style;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};